/*
 * hp-localize-countdown-bar.js
 * ------------------------------------------------------------------
 * Lokalisiert die Countdown-/Announcement-Bar-App (CSS-Praefix hc_cd) in den
 * uebersetzten Shops (/en/ /fr/ /it/). Loest die Probleme der App auf einmal:
 *
 *  1) LINK: die App gibt den Button-Link als absolute .ch-URL aus -> in /en//fr//it/
 *     landet der Kunde zurueck im deutschen Shop. Wir setzen den Link auf die
 *     aktuelle Sprache um (Shopify.routes.root davor), Pfad UND Query (?sale=1%3A)
 *     bleiben erhalten. Den uebersetzten Handle macht Shopify selbst (301).
 *     Robust auch bei absoluter https://haghpowered.com/-Eingabe.
 *  2) PROMO-TEXT (pro Sale): Ueberschrift/Unterzeile/Button per DICT (unten pflegen).
 *  3) TIMER-LABELS (fix): TAGE/STUNDEN/MINUTEN/SEKUNDEN per LABELS (nie aendern).
 *
 * No-Op auf Deutsch. Fehlt ein Text, bleibt Deutsch stehen (nie kaputt).
 *
 * PRO SALE PFLEGEN: nur die 3 Texte in DICT anpassen, so wie in der App getippt
 * (inkl. Emoji). Der Vergleich ist tolerant: unsichtbare Steuerzeichen (LRM/RLM,
 * BOM, Soft-Hyphen) und doppelte Leerzeichen werden beidseitig ignoriert. Man muss
 * die in der App getippten Zeichen also NICHT nachbauen, nur den lesbaren Text.
 * LINK und LABELS brauchen NIE Pflege.
 * REVERT: <script>-Include in theme.liquid entfernen + diese Datei loeschen.
 * ------------------------------------------------------------------
 */
(function () {
  // "‎" = LEFT-TO-RIGHT MARK: unsichtbarer Platzhalter, den die App-Texte zum
  // Ausrichten der ✚-Zeichen verwenden. In den Werten mitfuehren, damit die
  // uebersetzte Zeile gleich aussieht wie die deutsche.
  var LRM = "‎";

  // Promo-Texte der Bar (pro Sale anpassen): deutscher Quelltext -> { en, fr, it }
  var DICT = {
    "✚ 10% AUF FAST ALLES ✚": {
      en: "✚" + LRM + " " + LRM + " 10% OFF ALMOST EVERYTHING " + LRM + " ✚",
      fr: "✚" + LRM + " " + LRM + " 10% SUR PRESQUE TOUT " + LRM + " ✚",
      it: "✚" + LRM + " " + LRM + " 10% SU QUASI TUTTO " + LRM + " ✚"
    },
    "FEIERE DEN 1. AUGUST MIT UNS": {
      en: "CELEBRATE SWISS NATIONAL DAY WITH US",
      fr: "FÊTEZ LE 1ER AOÛT AVEC NOUS",
      it: "FESTEGGIA IL 1° AGOSTO CON NOI"
    },
    "ALLE PRODUKTE ANSEHEN": {
      en: "SHOP ALL PRODUCTS",
      fr: "VOIR TOUS LES PRODUITS",
      it: "VEDI TUTTI I PRODOTTI"
    }
  };
  // Timer-Labels (fix, nie aendern): deutsch -> { en, fr, it }
  var LABELS = {
    "TAGE": { en: "DAYS", fr: "JOURS", it: "GIORNI" },
    "STUNDEN": { en: "HOURS", fr: "HEURES", it: "ORE" },
    "MINUTEN": { en: "MINUTES", fr: "MINUTES", it: "MINUTI" },
    "SEKUNDEN": { en: "SECONDS", fr: "SECONDES", it: "SECONDI" }
  };

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  }
  function lang() {
    var r = root();
    if (r === "/en/") return "en";
    if (r === "/fr/") return "fr";
    if (r === "/it/") return "it";
    return "de";
  }
  function localizeHref(href) {
    var r = root();
    if (r === "/" || !href) return href;                          // Deutsch = No-Op
    href = href.replace(/^https?:\/\/[^/]*highpowered\.ch/i, ""); // Domain weg
    href = href.replace(/^\/(en|fr|it)\//, "/");                  // bestehendes Praefix weg
    if (href.charAt(0) !== "/") href = "/" + href;                // sicher root-relativ
    return r.replace(/\/$/, "") + href;                           // /fr + /collections/...?sale=1%3A
  }
  // Vergleichsform: unsichtbare Steuerzeichen raus, Leerraum vereinheitlichen.
  // So matcht der Eintrag auch, wenn in der App unsichtbare Zeichen mitgetippt
  // wurden (genau daran ist der Abgleich sonst still gescheitert).
  function norm(s) {
    return (s || "")
      .replace(/[\u200B-\u200F\u2060\uFEFF\u00AD]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }
  function normalizeMap(map) {
    var out = {};
    for (var k in map) if (map.hasOwnProperty(k)) out[norm(k)] = map[k];
    return out;
  }
  var DICT_N = normalizeMap(DICT);
  var LABELS_N = normalizeMap(LABELS);

  function translateNodes(bar, sel, map, L) {
    var nodes = bar.querySelectorAll(sel);
    for (var i = 0; i < nodes.length; i++) {
      var t = map[norm(nodes[i].textContent)];
      if (t && t[L]) nodes[i].textContent = t[L];
    }
  }
  function apply(bar) {
    if (!bar || bar.getAttribute("data-hp-localized") === "1") return;
    var link = bar.querySelector(".hc_cd_button");
    if (link && link.getAttribute("href")) {
      link.setAttribute("href", localizeHref(link.getAttribute("href")));
    }
    var L = lang();
    if (L !== "de") {
      translateNodes(bar, ".hc_cd_heading, .hc_cd_subheading, .hc_cd_button", DICT_N, L); // Promo
      translateNodes(bar, ".hc_cd_timerlabel", LABELS_N, L);                              // Labels
    }
    bar.setAttribute("data-hp-localized", "1");
  }
  function applyAll() {
    var bars = document.querySelectorAll(".hc_cd");
    for (var i = 0; i < bars.length; i++) apply(bars[i]);
  }

  document.addEventListener("hc.hpCountdownLoaded", function (e) {
    apply((e && e.detail && e.detail.countdown) || document.querySelector(".hc_cd"));
  });
  if (document.readyState !== "loading") applyAll();
  document.addEventListener("DOMContentLoaded", applyAll);
})();
